import { Utility } from './UtilityHelpers';

const calculateItemValues = (item: any): any => {
    const price = item.item_price || 0; 
    const quantity = item.item_quantity || 0;
    const discountPercentage = item.item_discount_percentage || 0;
    const discountAmount = item.item_discount_amount || 0;
    const depositPercentage = item.item_deposit_percentage || 0;
    const depositAmount = item.item_deposit_amount || 0;
    const tax1Percentage = item.item_tax1_percentage || 0;
    const tax2Percentage = item.item_tax2_percentage || 0;
    const tax3Percentage = item.item_tax3_percentage || 0;
    let tax1Amount = item.item_tax1_amount || 0;
    let tax2Amount = item.item_tax2_amount || 0;
    let tax3Amount = item.item_tax3_amount || 0;
  
    // Calculate gross amount (price * quantity)
    const grossAmount = price * quantity;
  
    // Calculate discount (either percentage or fixed amount)
    const calculatedDiscount = discountPercentage != 0 ? (grossAmount * discountPercentage) / 100 : discountAmount;
  
    // Calculate deposit (either percentage or fixed amount)
    const calculatedDeposit = depositPercentage != 0 ? (grossAmount * depositPercentage) / 100 : depositAmount;
  
    let taxableAmount = Utility.Maths.toDecimal(grossAmount);

    // Taxable amount (after discount and deposit)
    taxableAmount -= Utility.Maths.toDecimal(calculatedDiscount);
    taxableAmount += Utility.Maths.toDecimal(calculatedDeposit);

    taxableAmount = Utility.Maths.toDecimal(taxableAmount);
  
    // Calculate taxes
    if(tax1Percentage> 0){
      tax1Amount = taxableAmount * tax1Percentage / 100;
    }
    if(tax2Percentage> 0){
      tax2Amount = taxableAmount * tax2Percentage / 100;
    }
    if(tax3Percentage> 0){
      tax3Amount = taxableAmount * tax3Percentage / 100;
    }
    
    // Net amount after applying all taxes
    let netAmount = Utility.Maths.toDecimal(taxableAmount)
    if(tax1Amount > 0){
      netAmount += Utility.Maths.toDecimal(tax1Amount);
    }
    if(tax2Amount > 0){
      netAmount += Utility.Maths.toDecimal(tax2Amount);
    }
    if(tax3Amount > 0){
      netAmount += Utility.Maths.toDecimal(tax3Amount);
    }
    // Assuming paid amount is equal to net amount for now
    netAmount = Utility.Maths.toDecimal(netAmount);

    console.log('Calculated Values:', netAmount);
  
    return {
      ...item,
      item_gross_amount: Utility.Maths.toDecimal(grossAmount),
      item_discount_amount: Utility.Maths.toDecimal(calculatedDiscount),
      item_deposit_amount: Utility.Maths.toDecimal(calculatedDeposit),
      item_taxable_amount: Utility.Maths.toDecimal(taxableAmount),
      item_tax1_amount: Utility.Maths.toDecimal(tax1Amount),
      item_tax2_amount: Utility.Maths.toDecimal(tax2Amount),
      item_tax3_amount: Utility.Maths.toDecimal(tax3Amount),
      item_net_amount: Utility.Maths.toDecimal(netAmount),
    };
  };

  const calculateGrandTotals = (items: any[], formName: string) => {
    const totals = items.reduce(
      (totals, item) => {
        if(!item.selected)
        {
          totals[`${formName}_gross_amount`] += item.item_gross_amount || 0;
          totals[`${formName}_discount_amount`] += item.item_discount_amount || 0;
          totals[`${formName}_deposit_amount`] += item.item_deposit_amount || 0;
          totals[`${formName}_taxable_amount`] += item.item_taxable_amount || 0;
          totals[`${formName}_tax_amount`] += item.item_tax1_amount || 0;
          totals[`${formName}_net_amount`] += item.item_net_amount || 0;
        }
        
        return totals;
      },
      {
        [`${formName}_gross_amount`]: 0,
        [`${formName}_discount_amount`]: 0,
        [`${formName}_deposit_amount`]: 0,
        [`${formName}_taxable_amount`]: 0,
        [`${formName}_tax_amount`]: 0,
        [`${formName}_net_amount`]: 0,
      }
    );
  
    // Round each value to two decimal places
    totals[`${formName}_gross_amount`] = Utility.Maths.toDecimal(totals[`${formName}_gross_amount`]);
    totals[`${formName}_discount_amount`] = Utility.Maths.toDecimal(totals[`${formName}_discount_amount`]);
    totals[`${formName}_deposit_amount`] = Utility.Maths.toDecimal(totals[`${formName}_deposit_amount`]);
    totals[`${formName}_taxable_amount`] = Utility.Maths.toDecimal(totals[`${formName}_taxable_amount`]);
    totals[`${formName}_tax_amount`] = Utility.Maths.toDecimal(totals[`${formName}_tax_amount`]);
    totals[`${formName}_net_amount`] = Utility.Maths.toDecimal(totals[`${formName}_net_amount`]);
  
    return totals;
  };

  const calculateSubTotals = (items: any[], formName: string) => {
    const totals = items.reduce(
      (totals, item) => {
        totals[`${formName}_gross_amount`] += item.item_gross_amount || 0;
        totals[`${formName}_discount_amount`] += item.item_discount_amount || 0;
        totals[`${formName}_deposit_amount`] += item.item_deposit_amount || 0;
        totals[`${formName}_taxable_amount`] += item.item_taxable_amount || 0;
        totals[`${formName}_tax1_amount`] += item.item_tax1_amount || 0;
        totals[`${formName}_net_amount`] += item.item_net_amount || 0;
        
        return totals;
      },
      {
        [`${formName}_gross_amount`]: 0,
        [`${formName}_discount_amount`]: 0,
        [`${formName}_deposit_amount`]: 0,
        [`${formName}_taxable_amount`]: 0,
        [`${formName}_tax1_amount`]: 0,
        [`${formName}_net_amount`]: 0,
      }
    );
  
    // Round each value to two decimal places
    totals[`${formName}_gross_amount`] = Utility.Maths.toDecimal(totals[`${formName}_gross_amount`]);
    totals[`${formName}_discount_amount`] = Utility.Maths.toDecimal(totals[`${formName}_discount_amount`]);
    totals[`${formName}_deposit_amount`] = Utility.Maths.toDecimal(totals[`${formName}_deposit_amount`]);
    totals[`${formName}_taxable_amount`] = Utility.Maths.toDecimal(totals[`${formName}_taxable_amount`]);
    totals[`${formName}_tax1_amount`] = Utility.Maths.toDecimal(totals[`${formName}_tax1_amount`]);
    totals[`${formName}_net_amount`] = Utility.Maths.toDecimal(totals[`${formName}_net_amount`]);
  
    return totals;
  };


export const Calculate= {
    ItemValues: calculateItemValues,
    GrandTotals: calculateGrandTotals,
    SubTotals: calculateSubTotals,
}